import { API_BASE_URL } from '../globals';
import {
  SEARCH_VEHICLE_VENDOR,
  FETCH_VENDOR_PAYOUT_LOGS,
  DOWNLOAD_VENDOR_PAYOUT_LOGS,
  CALCULATE_VENDOR_PAYOUT,
} from './routes';
import { GET, POST } from './apiHandler';

export const getSearchedVendorDetails = async (params) => {
  return GET(`${API_BASE_URL}${SEARCH_VEHICLE_VENDOR}`, params);
};

export const getVendorPayoutData = async (params) => {
  return GET(`${API_BASE_URL}${FETCH_VENDOR_PAYOUT_LOGS}`, params);
};

export const downloadVendorPayoutData = async (params) => {
  return GET(`${API_BASE_URL}${DOWNLOAD_VENDOR_PAYOUT_LOGS}`, params);
};

export const calculateVendorPayout = async (params) => {
  return POST(`${API_BASE_URL}${CALCULATE_VENDOR_PAYOUT}`, params);
};
